import { useQuery } from 'react-query'
import { AxiosError } from 'axios'

import { fetchAPI } from '@/lib/api'
import { ADMIN_COMPANIES } from '../constants'

type Params = {
  search?: string
}

export type CompanyOption = {
  id: string
  name: string
}

export type Option = {
  label: string
  value: string
}

async function getCompanyOptions({ search }: Params): Promise<Option[]> {
  const { data } = await fetchAPI<{
    companies: CompanyOption[]
  }>({
    path: `/admins/companies`,
    params: { search },
  })

  const options =
    data?.companies?.map((datum) => ({
      label: datum.name,
      value: datum.id,
    })) || []

  return options
}

export const useCompanyOptions = (params: Params) => {
  return useQuery<Option[], AxiosError>({
    queryKey: [ADMIN_COMPANIES, params],
    queryFn: () => getCompanyOptions(params),
    enabled: !!params.search,
  })
}
